export enum ProductPermissions {
  PO_SUBTYPE_REQUIRED = 'PO_SUBTYPE_REQUIRED',
  CAN_SELECT_PO_SUB_TYPE = 'PO_SUB_FILTER',
  AUTO_PRICING = 'PO_AUTO_PRICING',
  EDITABLE_PRICING = 'WEEKLY_RATE_TERM'
}
